/**
 * How long a login lasts.
 *
 * Firebase refresh tokens are effectively permanent, so a signed-in browser
 * would otherwise stay signed in for months. Requirement 4 asks for a login
 * session of about a day, so we cap it against the ID token's `auth_time`
 * claim — the moment the user actually proved who they are (Google popup, or
 * redeeming an OTP custom token). Token refreshes do not move `auth_time`, so
 * the cap cannot be extended by simply staying active.
 *
 * Shared by the browser (which signs the user out on expiry) and the API routes
 * (which reject the token, so a stale tab cannot keep writing data).
 */
export const MAX_SESSION_AGE_MS = 24 * 60 * 60 * 1000; // 1 day

/** Milliseconds until the session ends; 0 once it has. */
export function sessionTimeRemainingMs(authTimeSeconds?: number): number {
  if (!authTimeSeconds) return MAX_SESSION_AGE_MS;
  const remaining = authTimeSeconds * 1000 + MAX_SESSION_AGE_MS - Date.now();
  return remaining > 0 ? remaining : 0;
}

export function isSessionExpired(authTimeSeconds?: number): boolean {
  return sessionTimeRemainingMs(authTimeSeconds) === 0;
}
